import HeroSection from "./heroSection.jsx";
import FeaturesDetails from "./featuresDetails.jsx";
import FeatureBanner from "./featureBanner.jsx";
import Newsletter from "./newsletter.jsx";
import { useEffect } from "react";

function Home() {
  useEffect(() => {
    document.title = "Home - Optix360";
  }, []);
  return (
    <div>
      <HeroSection />
      <FeaturesDetails />
      <FeatureBanner />
      <Newsletter />
    </div>
  );
}

export default Home;